import { defineComponent as _defineComponent } from 'vue'
import {computed, reactive, ref} from "vue";

import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import FileuploadDropzone from "@/components/forms/files/FileuploadDropzone.vue";
import SingleFileuploadItem from "@/components/forms/files/SingleFileuploadItem.vue";
import SelectedDocumentFile from "@/components/forms/files/SelectedDocumentFile.vue";
import InlineSvg from "vue-inline-svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleDocumentFilesTableUpload',
  props: {
  value: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  checkDuples: {
    type: Boolean,
    default: false,
  },
  maxFileSize: {
    type: Number,
    default: 10485760,
  },
  accept: {
    type: String,
    default: 'application/pdf,image/jpeg,image/png',
  },
  fileUploadUrl: {
    type: String,
    default: '/webapi/finance/incomingwire?call=uploadFile&m[name]=filecontents',
  },
  maxFiles: {
    default: 10,
    type: Number
  }
},
  emits: ['update:value', 'input', 'upload-start', 'upload-end'],
  setup(__props, { expose, emit }) {

const props = __props;



const dropzone = ref(null)

const uploadingStatus = reactive(new RemoteRequestState())
const fileUpload = ref(null)
const fileUploadBusy = computed(() => uploadingStatus.isLoading)


const filesUnderUpload = ref([])

const browseDisabled = computed(() => {
  return props.disabled || filesCountReached.value ;
})

// const onFileUpload = (event) => {
//   uploadingStatus.loadEnd()
//   const fileData = JSON.parse(event.xhr.response)
//   emit('upload-end', fileData)
//   // console.log('onUpload: ', event, event.xhr, event.files);
//   // console.log('response: ', fileData);
//   valueFiles.value.splice(valueFiles.value.length, 0, ...fileData);
//
//   //debugger
//   const filesIds = fileData.map((file) => convertCapitalistFileToOurFile(file).fileid)
//
//   // console.log('filter ids', filesIds)
//   filesUnderUpload.value = filesUnderUpload.value.filter((f) => {
//     return filesIds.indexOf(f.id) == -1;
//   })
// }

const onSingleFileUpload = (event) => {
  console.log('onSingleFileUpload', event);
  const fileData = JSON.parse(event.xhr.response)
  const tempFileId = event.meta.listid;

  if (tempFileId !== null) {
    const idx = selectedFiles.value.findIndex((f) => {
      return f.listid == tempFileId;
    });
    if (idx >= 0)
    {
      selectedFiles.value[idx].id = fileData[0].id;
      selectedFiles.value[idx].uploaded = true;
      selectedFiles.value[idx].uploading = false;
    }
  }

  const fd = fileData.map((f) => ({...f, listid: tempFileId}));
  valueFiles.value.splice(valueFiles.value.length, 0, ...fd);

  //debugger
  // const filesIds = fileData.map((file) => convertCapitalistFileToOurFile(file).fileid)

  // console.log('filter ids', filesIds)
  filesUnderUpload.value = filesUnderUpload.value.filter((f) => {
    return f.listid !== tempFileId;
  })

  uploadingStatus.loadEnd();
}


const onFileSelect = ({originalEvent, files}) => {
  // console.log('onFileSelect', files);
  const res = files.map((file) => {
    return convertBrowserFileToOurFile(file)
  })
  const existFileIds = selectedFiles.value.filter((f) => f.uploaded || f.uploading).map((f) => f.fileid);
  res.forEach((el) => {
    if (!props.checkDuples || (existFileIds.indexOf(el.fileid) < 0))
      selectedFiles.value.push(el);
  })
  dropzone.value.clear();
  ///selectedFiles.value.splice(selectedFiles.value.length,0, ...res);
}

const onSingleFileUploadError = (event) => {
  const response = JSON.parse(event.xhr.response)
  emit('upload-end', null, response)

  filesUnderUpload.value = filesUnderUpload.value.filter((f) => {
    return f.listid !== event.meta.listid;
  })

  console.log('onSingleFileUploadError', event)

  selectedFiles.value.forEach((file, idx) => {
    if (file.listid == event.meta.listid) {
      selectedFiles.value[idx].uploading = false;
      selectedFiles.value[idx].uploaded = false;
      selectedFiles.value[idx].error = true;
    }
  })

  uploadingStatus.loadError()
}


const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    // eslint-disable-next-line no-mixed-operators
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8
    return v.toString(16)
  })
}

const convertBrowserFileToOurFile = (file) => {
  return {
    id: '',
    listid: uuidv4(),
    filename: file.name,
    mimetype: file.type,
    name: file.name,
    size: file.size,
    type: file.type,
    fileid: [file.name, file.size, file.type].join(':'),
    origFile: file,
    uploaded: false,
    uploading: false,
    error: false
  }
}

const convertCapitalistFileToOurFile = (file) => {
  return {
    filename: file.filename,
    mimetype: file.mimetype,
    name: file.filename,
    size: file.size,
    type: file.mimetype,
    fileid: [file.filename, file.size, file.mimetype].join(':')
  }
}


const onFileUploadStart = (data) => {
  const file = selectedFiles.value.find((f) => f.listid == data.meta.listid);
  if (file) {
    filesUnderUpload.value.splice(filesUnderUpload.value.length, 0, file);
  }
  // console.log('onFilesUploadStart', data.files.map((file) => convertBrowserFileToOurFile(file)))
}


const onBeforeUpload = (event) => {
  uploadingStatus.loadStart()
  selectedFiles.value.findIndex((file) => {
    if (file.listid == event.meta.listid) {
      file.uploading = true;
      file.uploaded = false;
    }
  })
  emit('upload-start')
  // console.log('onBeforeUpload: ', event);
}

const valueFiles = computed({
  get: () => props.value,
  set: (value) => {
    emit('update:value', value)
    emit('input', value)
  },
})

const filesCountReached = computed(() => {
  return props.maxFiles > 0
    && (successUploadedCount.value + inprocessUploadingCount.value) >= props.maxFiles;
})

const successfilesCountReached = computed(() => {
  return props.maxFiles > 0
    && (successUploadedCount.value) >= props.maxFiles;
})

const inprocessUploadingCount = computed(() => {
  return filesUnderUpload.value.length;
})

const successUploadedCount = computed(() => {
  return selectedFiles.value.filter((file) => file.uploaded).length;
})

// const combinedFiles = computed(() => {
//   const result = [
//     // ...valueFiles.value.map((file) => {
//     //   return Object.assign(convertCapitalistFileToOurFile(file), {
//     //     uploaded: true,
//     //     uploading: false
//     //   })
//     // }),
//     ...selectedFiles.value.map((file) => {
//       return Object.assign(file, {
//         //uploaded: false,
//         uploading: isFileUploading(file)
//       })
//     })];
//   //
//   // selectedFiles.value.map((file) => {
//   //   return Object.assign(file, {
//   //     uploaded: false,
//   //     uploading: isFileUploading(file)
//   //   })
//   // })
//
//   return result;
//   // selectedFiles.value
//   // filesUnderUpload
// })

const isFileUploading = (file) => {
  return filesUnderUpload.value.findIndex((f) => {
    return f.id == file.listid;
  }) >= 0;
}

const selectedFiles = ref([])

const busy = computed(() => uploadingStatus.isLoading)

const removeFile = (id) => {
  if (props.disabled)
    return;
  // console.log('removeFile', id, valueFiles.value, selectedFiles.value);
  let idx = selectedFiles.value.findIndex((file) => file.listid == id)
  if (idx >= 0) selectedFiles.value.splice(idx, 1);
  idx = valueFiles.value.findIndex((file) => file.listid == id);
  if (idx >= 0) valueFiles.value.splice(idx, 1);
  idx = filesUnderUpload.value.findIndex((file) => file.listid == id);
  if (idx >= 0) filesUnderUpload.value.splice(idx, 1);
  //valueFiles.value = valueFiles.value.filter((file) => file.id != id);
  // const idx = valueFiles.value.findIndex((file) => file.id == id);
  // if (idx >= 0)
  //     valueFiles.value.splice(idx, 1)
  //selectedFiles.value.splice(selectIndex, 1)
}

const clear = () => {
  selectedFiles.value.splice(0);
  valueFiles.value.splice(0);
  dropzone.value.clear();
}

expose({
  uploadingStatus,
  filesUnderUpload,
  busy,
  clear,
})

return { __sfc: true,props, dropzone, uploadingStatus, fileUpload, fileUploadBusy, emit, filesUnderUpload, browseDisabled, onSingleFileUpload, onFileSelect, onSingleFileUploadError, uuidv4, convertBrowserFileToOurFile, convertCapitalistFileToOurFile, onFileUploadStart, onBeforeUpload, valueFiles, filesCountReached, successfilesCountReached, inprocessUploadingCount, successUploadedCount, isFileUploading, selectedFiles, busy, removeFile, clear, computed, reactive, ref, RemoteRequestState, FileuploadDropzone, SingleFileuploadItem, SelectedDocumentFile, InlineSvg }
}

})